var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatFilePendingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.36434 1.76444C7.23113 1.56112 8.11556 1.45946 9 1.45946C9.40301 1.45946 9.72973 1.13275 9.72973 0.72973C9.72973 0.326711 9.40301 0 9 0C8.00372 0 7.00744 0.114517 6.03105 0.343549C3.209 1.00551 1.00551 3.20899 0.343549 6.03104C-0.114516 7.98385 -0.114516 10.0162 0.343549 11.969C1.00551 14.791 3.209 16.9945 6.03105 17.6565C7.98385 18.1145 10.0162 18.1145 11.969 17.6565C14.791 16.9945 16.9945 14.791 17.6565 11.969C17.8855 10.9925 18 9.99625 18 8.99997C18 8.59695 17.6733 8.27024 17.2703 8.27024C16.8673 8.27025 16.5405 8.59696 16.5405 8.99998C16.5405 9.88442 16.4389 10.7689 16.2356 11.6357C15.7002 13.9181 13.9181 15.7002 11.6357 16.2356C9.90208 16.6422 8.09792 16.6422 6.36434 16.2356C4.08194 15.7002 2.29982 13.9181 1.76444 11.6357C1.3578 9.90208 1.3578 8.09792 1.76444 6.36434C2.29982 4.08194 4.08194 2.29982 6.36434 1.76444Z",
    fill: "#28447B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8378 0.486486C13.0914 0.486486 11.6757 1.90223 11.6757 3.64865C11.6757 5.39506 13.0914 6.81081 14.8378 6.81081C16.5843 6.81081 18 5.39506 18 3.64865C18 1.90223 16.5843 0.486486 14.8378 0.486486Z",
    fill: "#28447B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatFilePendingIcon);
export default __webpack_public_path__ + "static/media/chatFilePendingIcon.f37b984e.svg";
export { ForwardRef as ReactComponent };